<!-- eslint-disable -->
<template>
  <div v-show="C_isVisible" class="image-button-container">
    <a 
      @mousedown="eventMouseDown(P_buttonId, P_makeSingleEvent, DV_shutdownButton)"
      @mouseup="eventMouseRelease(P_buttonId, P_makeSingleEvent, DV_shutdownButton)"
      @click="eventMouseClick(P_buttonId, P_makeSingleEvent, DV_shutdownButton)"
      class="image-button image-button-shutdown"
      :class="{active: C_isActiveState}"
    ></a>
    {{P_buttonText}}
  </div>
</template>

<script>
/* eslint-disable */
import { bi10GridComponent } from "../../../watchdog_includes/base_i10_UI_mixins"

export default {
  props: ["P_buttonText", "P_buttonId", 'P_makeSingleEvent', 'P_customCss'],
  data () {
    return {
      DV_shutdownButton: true
    }
  },
  mixins: [bi10GridComponent]
}
</script>

<style lang="less" scoped>
.image-button-container {
  width: 100%;
  height: 100%;
  font-weight: 500;
  color: var(--font-color1);
  .image-button {
    display: block;
    height: 100%;
    width: 100%; 
    background-position: center;
    background-repeat: no-repeat;
    background-size: 80%, 85%;
    &.image-button-shutdown {
      background-image: url(/dynamic/images/b1/NU_GUI/power.png), url(/dynamic/images/b1/NU_GUI/black.png);
      &:active {
        background-image: url(/dynamic/images/b1/NU_GUI/power.png), url(/dynamic/images/b1/NU_GUI/blue.png);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Grid/NU_GUI/GShutdownButton.vue